import { register as ErrorService } from '@crochik/pi-react/services/ErrorService';
import { register as ExceptionService } from './Exception';
import initData from './Data';

export default function register() {
    ErrorService();
    ExceptionService();
    initData();
}


// WEBPACK FOOTER //
// ./src/app/services/index.ts